
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"180","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".16","d":"M190.654 39.046c0 24.925-21.748 45.193-48.654 45.193-26.906 0-48.654-20.268-48.654-45.193 0-24.925 21.748-45.192 48.654-45.192 26.906 0 48.654 20.267 48.654 45.192z","stroke":"#000C1F"}}),_c('path',{attrs:{"opacity":".12","d":"M223.423 39.046c0 41.749-36.419 75.654-81.423 75.654-45.004 0-81.423-33.905-81.423-75.654 0-41.749 36.42-75.654 81.423-75.654 45.004 0 81.423 33.905 81.423 75.654z","stroke":"#000C1F"}}),_c('path',{attrs:{"opacity":".08","d":"M256.192 39.046c0 58.572-51.09 106.116-114.192 106.116-63.102 0-114.192-47.544-114.192-106.116S78.898-67.069 142-67.069c63.102 0 114.192 47.543 114.192 106.115z","stroke":"#000C1F"}}),_c('path',{attrs:{"opacity":".04","d":"M283.5 39.046c0 72.592-63.317 131.5-141.5 131.5-78.183 0-141.5-58.908-141.5-131.5 0-72.591 63.317-131.5 141.5-131.5 78.183 0 141.5 58.908 141.5 131.5z","stroke":"#000C1F"}})])
          )
        }
      }
    